import { UserRole } from '@scts/models';
import { createContext, useContext } from 'react';

export type AuthContextType = {
  userRole: UserRole;
  setUserRole: (value: UserRole) => void;
};

// create context
export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);

// custom context hook from context
export const useAuthContext = () => {
  const authState = useContext(AuthContext);

  if (authState === null) {
    console.log('Auth Error: auth role not available');
  }

  return authState;
};
